import { Link } from 'react-router-dom';
import { ScrollSection } from '../components/ScrollSection';

function BillsPayments() {
  return (
    <>
      {/* Hero Section */}
      <div
        className="container-fluid page-header wow fadeIn"
        data-wow-delay="0.1s"
        style={{
          // background: 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(/img/Insurance.jpeg)',
          backgroundColor: '#0066cc',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="container text-center py-5 mt-4">
          <h1 className="display-2 text-white fw-bold mb-3 animated slideInDown" style={{ fontFamily: 'Georgia, serif' }}>
            Bills & Payments
          </h1>
          <nav aria-label="breadcrumb animated slideInDown">
            <ol className="breadcrumb justify-content-center mb-0">
              <li className="breadcrumb-item fw-bold">
                <Link to="/" className="text-white">
                  Home
                </Link>
              </li>
              <li className="breadcrumb-item fw-bold text-white" aria-current="page">
                Bills & Payments
              </li>
            </ol>
          </nav>
        </div>
      </div>

      {/* Main Content */}
      <div className="container py-5" style={{ maxWidth: '1200px' }}>
        {/* Introductory Section */}
        <ScrollSection>
          <div style={{ marginBottom: '80px' }}>
            <p style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6', marginBottom: '2rem' }}>
              Tema General Hospital is committed to transparent billing and structured payment processes to support patients while ensuring accountability.
            </p>
          </div>
        </ScrollSection>

        {/* Section 1: TGH Billing & Payment Process */}
        <ScrollSection>
          <div style={{ marginBottom: '80px' }}>
            <h2 className="mb-4" style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#0066cc', lineHeight: '1.2', fontFamily: 'Georgia, serif' }}>
              TGH Billing & Payment Process
            </h2>
            <p style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6', marginBottom: '2rem' }}>
              Billing and payment at TGH involve <strong>three key units</strong>: <strong>Records → Accounts Office → Bank Teller</strong>, with <strong>Social Services support</strong> where needed.
            </p>

            <h3 className="mb-3" style={{ fontSize: '1.5rem', fontWeight: '600', color: '#000' }}>
              How the Process Works
            </h3>

            <div className="row g-4 mb-4">
              <div className="col-md-6 col-lg-4">
                <div className="p-4" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px', height: '100%' }}>
                  <h4 style={{ fontSize: '1.2rem', fontWeight: '600', color: '#000', marginBottom: '1rem' }}>
                    <i className="bi bi-1-circle-fill me-2" style={{ color: '#0066cc' }}></i>
                    Registration & Insurance Verification
                  </h4>
                  <p style={{ fontSize: '1rem', color: '#333', lineHeight: '1.6', marginBottom: 0 }}>
                    Patients are registered at the <strong>Records Unit</strong>, where insurance validity is checked.
                  </p>
                </div>
              </div>
              <div className="col-md-6 col-lg-4">
                <div className="p-4" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px', height: '100%' }}>
                  <h4 style={{ fontSize: '1.2rem', fontWeight: '600', color: '#000', marginBottom: '1rem' }}>
                    <i className="bi bi-2-circle-fill me-2" style={{ color: '#0066cc' }}></i>
                    Service Delivery
                  </h4>
                  <p style={{ fontSize: '1rem', color: '#333', lineHeight: '1.6', marginBottom: 0 }}>
                    Charges are generated as services are provided (consultation, lab tests, imaging, medications, admission).
                  </p>
                </div>
              </div>
              <div className="col-md-6 col-lg-4">
                <div className="p-4" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px', height: '100%' }}>
                  <h4 style={{ fontSize: '1.2rem', fontWeight: '600', color: '#000', marginBottom: '1rem' }}>
                    <i className="bi bi-3-circle-fill me-2" style={{ color: '#0066cc' }}></i>
                    Bill Preparation
                  </h4>
                  <p style={{ fontSize: '1rem', color: '#333', lineHeight: '1.6', marginBottom: 0 }}>
                    The <strong>Accounts Office</strong> prepares and explains the patient's bill, including insurance-covered services and non-covered or out-of-pocket charges.
                  </p>
                </div>
              </div>
              <div className="col-md-6 col-lg-4">
                <div className="p-4" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px', height: '100%' }}>
                  <h4 style={{ fontSize: '1.2rem', fontWeight: '600', color: '#000', marginBottom: '1rem' }}>
                    <i className="bi bi-4-circle-fill me-2" style={{ color: '#0066cc' }}></i>
                    Payment
                  </h4>
                  <p style={{ fontSize: '1rem', color: '#333', lineHeight: '1.6', marginBottom: 0 }}>
                    Patients make payments <strong>only at the Bank Teller</strong>, not at the Accounts Office.
                  </p>
                </div>
              </div>
              <div className="col-md-6 col-lg-4">
                <div className="p-4" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px', height: '100%' }}>
                  <h4 style={{ fontSize: '1.2rem', fontWeight: '600', color: '#000', marginBottom: '1rem' }}>
                    <i className="bi bi-5-circle-fill me-2" style={{ color: '#0066cc' }}></i>
                    Receipt & Service Continuation
                  </h4>
                  <p style={{ fontSize: '1rem', color: '#333', lineHeight: '1.6', marginBottom: 0 }}>
                    An official bank receipt is presented at the relevant service point before services continue or discharge is completed.
                  </p>
                </div>
              </div>
            </div>

            <div className="p-4" style={{ backgroundColor: '#e7f3ff', borderRadius: '8px', borderLeft: '4px solid #0066cc' }}>
              <p style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6', marginBottom: 0 }}>
                <strong>Important:</strong> The Accounts Office <strong>does not collect payments</strong>; it only prepares and explains bills.
              </p>
            </div>
          </div>
        </ScrollSection>

        {/* Section 2: Viewing Your Hospital Bill */}
        <ScrollSection>
          <div style={{ marginBottom: '80px' }}>
            <h2 className="mb-4" style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#0066cc', lineHeight: '1.2', fontFamily: 'Georgia, serif' }}>
              Viewing Your Hospital Bill
            </h2>
            <p style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6', marginBottom: '1rem' }}>
              Patients may view and review their bills at:
            </p>
            <ul style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.8', marginBottom: '2rem' }}>
              <li>The <strong>Accounts Office</strong></li>
              <li>The <strong>Ward</strong> (for admitted patients)</li>
              <li>Before proceeding to payment at the bank teller</li>
            </ul>
            <div className="p-3" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
              <p style={{ fontSize: '1rem', color: '#333', lineHeight: '1.6', marginBottom: 0 }}>
                Patients are encouraged to ask for a <strong>clear explanation</strong> of charges before making payment.
              </p>
            </div>
          </div>
        </ScrollSection>

        {/* Section 3: Making Payments at the Bank Teller */}
        <ScrollSection>
          <div style={{ marginBottom: '80px' }}>
            <h2 className="mb-4" style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#0066cc', lineHeight: '1.2', fontFamily: 'Georgia, serif' }}>
              Making Payments at the Bank Teller
            </h2>

            <h3 className="mb-3" style={{ fontSize: '1.5rem', fontWeight: '600', color: '#000' }}>
              Where Payments Are Made
            </h3>
            <p style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6', marginBottom: '2rem' }}>
              All hospital payments are made at the <strong>designated Bank Teller within the hospital premises</strong>.
            </p>

            <h3 className="mb-3" style={{ fontSize: '1.5rem', fontWeight: '600', color: '#000' }}>
              Payment Notes
            </h3>
            <ul style={{ fontSize: '1rem', color: '#333', lineHeight: '1.8', marginBottom: 0 }}>
              <li>Payments must match the bill issued by the Accounts Office.</li>
              <li>Patients must <strong>collect and keep official bank receipts</strong>.</li>
              <li>Receipts may be required before:
                <ul style={{ marginTop: '0.5rem' }}>
                  <li>Laboratory tests</li>
                  <li>Imaging services</li>
                  <li>Medication dispensing</li>
                  <li>Discharge (for admitted patients)</li>
                </ul>
              </li>
            </ul>
          </div>
        </ScrollSection>

        {/* Section 4: Understanding Your TGH Bill */}
        <ScrollSection>
          <div style={{ marginBottom: '80px' }}>
            <h2 className="mb-4" style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#0066cc', lineHeight: '1.2', fontFamily: 'Georgia, serif' }}>
              Understanding Your TGH Bill
            </h2>
            <p style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6', marginBottom: '1rem' }}>
              A hospital bill may include:
            </p>
            <ul style={{ fontSize: '1rem', color: '#333', lineHeight: '1.8', marginBottom: '2rem' }}>
              <li>Consultation fees</li>
              <li>Laboratory and diagnostic tests</li>
              <li>Imaging services</li>
              <li>Medications</li>
              <li>Procedures or surgeries</li>
              <li>Admission and ward charges</li>
              <li>Services not covered by insurance</li>
            </ul>

            <h3 className="mb-3" style={{ fontSize: '1.5rem', fontWeight: '600', color: '#000' }}>
              Important Information
            </h3>
            <ul style={{ fontSize: '1rem', color: '#333', lineHeight: '1.8', marginBottom: '2rem' }}>
              <li>NHIS and private insurance do <strong>not cover all services</strong></li>
              <li>Some items require <strong>out-of-pocket payment</strong></li>
              <li>Charges accumulate for admitted (IPD) patients during their stay</li>
            </ul>

            <div className="p-3" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
              <p style={{ fontSize: '1rem', color: '#333', lineHeight: '1.6', marginBottom: 0 }}>
                Hospital staff are available to explain all bill items.
              </p>
            </div>
          </div>
        </ScrollSection>

        {/* Section 5: Inpatient (IPD) Billing & Discharge */}
        <ScrollSection>
          <div style={{ marginBottom: '80px' }}>
            <h2 className="mb-4" style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#0066cc', lineHeight: '1.2', fontFamily: 'Georgia, serif' }}>
              Inpatient (IPD) Billing & Discharge
            </h2>

            <h3 className="mb-3" style={{ fontSize: '1.5rem', fontWeight: '600', color: '#000' }}>
              For Admitted Patients
            </h3>
            <ul style={{ fontSize: '1rem', color: '#333', lineHeight: '1.8', marginBottom: 0 }}>
              <li>Bills accumulate throughout admission</li>
              <li>Interim bills may be shared with patients or relatives</li>
              <li><strong>Final bills must be cleared before discharge</strong>, unless otherwise approved</li>
            </ul>
          </div>
        </ScrollSection>

        {/* Section 6: Support for Patients Unable to Pay (IPD) */}
        <ScrollSection>
          <div style={{ marginBottom: '80px' }}>
            <h2 className="mb-4" style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#0066cc', lineHeight: '1.2', fontFamily: 'Georgia, serif' }}>
              Support for Patients Unable to Pay (IPD)
            </h2>
            <p style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6', marginBottom: '2rem' }}>
              Tema General Hospital recognizes that some patients may face financial difficulties.
            </p>

            <h3 className="mb-3" style={{ fontSize: '1.5rem', fontWeight: '600', color: '#000' }}>
              Social Services Support
            </h3>
            <ul style={{ fontSize: '1rem', color: '#333', lineHeight: '1.8', marginBottom: '2rem' }}>
              <li><strong>Inpatient (IPD) patients who are unable to pay their bills</strong> may be referred to the <strong>Social Services Unit</strong>.</li>
              <li>Social Services may:
                <ul style={{ marginTop: '0.5rem' }}>
                  <li>Assess the patient's situation</li>
                  <li>Provide guidance on available support options</li>
                  <li>Recommend assistance in line with hospital policy</li>
                </ul>
              </li>
            </ul>

            <div className="p-4" style={{ backgroundColor: '#e7f3ff', borderRadius: '8px', borderLeft: '4px solid #0066cc' }}>
              <p style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6', marginBottom: 0 }}>
                Referral to Social Services is done through ward staff or hospital administration.
              </p>
            </div>
          </div>
        </ScrollSection>

        {/* Section 7: Insurance & Billing Differences */}
        <ScrollSection>
          <div style={{ marginBottom: '80px' }}>
            <h2 className="mb-4" style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#0066cc', lineHeight: '1.2', fontFamily: 'Georgia, serif' }}>
              Insurance & Billing Differences
            </h2>

            <div className="row g-4">
              <div className="col-md-6">
                <div className="p-4" style={{ backgroundColor: '#fff', borderRadius: '8px', border: '1px solid #e0e0e0', height: '100%' }}>
                  <h3 className="mb-3" style={{ fontSize: '1.3rem', fontWeight: '600', color: '#000' }}>
                    Insured Patients
                  </h3>
                  <ul style={{ fontSize: '1rem', color: '#333', lineHeight: '1.8', marginBottom: 0 }}>
                    <li>Covered services are billed to the insurer</li>
                    <li>Patients pay only for:
                      <ul style={{ marginTop: '0.5rem' }}>
                        <li>Non-covered services</li>
                        <li>Expired or inactive insurance</li>
                        <li>Services outside benefit limits</li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-6">
                <div className="p-4" style={{ backgroundColor: '#fff', borderRadius: '8px', border: '1px solid #e0e0e0', height: '100%' }}>
                  <h3 className="mb-3" style={{ fontSize: '1.3rem', fontWeight: '600', color: '#000' }}>
                    Uninsured Patients
                  </h3>
                  <ul style={{ fontSize: '1rem', color: '#333', lineHeight: '1.8', marginBottom: 0 }}>
                    <li>All services are billed directly to the patient</li>
                    <li>Payments are made at the bank teller after billing by Accounts</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </ScrollSection>

        {/* Section 8: Questions, Errors & Billing Concerns */}
        <ScrollSection>
          <div style={{ marginBottom: '80px' }}>
            <h2 className="mb-4" style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#0066cc', lineHeight: '1.2', fontFamily: 'Georgia, serif' }}>
              Questions, Errors & Billing Concerns
            </h2>
            <p style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6', marginBottom: '1rem' }}>
              If you have concerns about your bill:
            </p>
            <ol style={{ fontSize: '1rem', color: '#333', lineHeight: '1.8', marginBottom: 0 }}>
              <li>Visit the <strong>Accounts Office</strong> for clarification</li>
              <li>Confirm insurance coverage</li>
              <li>Report any discrepancies promptly</li>
              <li>For financial hardship (IPD), request referral to <strong>Social Services</strong></li>
            </ol>
          </div>
        </ScrollSection>

        {/* Section 9: Frequently Asked Questions */}
        <ScrollSection>
          <div>
            <h2 className="mb-4" style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#0066cc', lineHeight: '1.2', fontFamily: 'Georgia, serif' }}>
              Frequently Asked Questions (FAQs)
            </h2>

            <div className="accordion" id="billsFAQAccordion">
              <div className="accordion-item" style={{ border: '1px solid #e0e0e0', borderRadius: '8px', marginBottom: '1rem' }}>
                <h2 className="accordion-header">
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#billsFaq1"
                    style={{ fontSize: '1.1rem', fontWeight: '600', color: '#000' }}
                  >
                    Who prepares my hospital bill?
                  </button>
                </h2>
                <div id="billsFaq1" className="accordion-collapse collapse show" data-bs-parent="#billsFAQAccordion">
                  <div className="accordion-body" style={{ fontSize: '1rem', color: '#333', lineHeight: '1.6' }}>
                    The <strong>Accounts Office</strong> prepares and explains all hospital bills.
                  </div>
                </div>
              </div>

              <div className="accordion-item" style={{ border: '1px solid #e0e0e0', borderRadius: '8px', marginBottom: '1rem' }}>
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#billsFaq2"
                    style={{ fontSize: '1.1rem', fontWeight: '600', color: '#000' }}
                  >
                    Where do I make payments?
                  </button>
                </h2>
                <div id="billsFaq2" className="accordion-collapse collapse" data-bs-parent="#billsFAQAccordion">
                  <div className="accordion-body" style={{ fontSize: '1rem', color: '#333', lineHeight: '1.6' }}>
                    All payments are made at the <strong>hospital bank teller</strong>.
                  </div>
                </div>
              </div>

              <div className="accordion-item" style={{ border: '1px solid #e0e0e0', borderRadius: '8px', marginBottom: '1rem' }}>
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#billsFaq3"
                    style={{ fontSize: '1.1rem', fontWeight: '600', color: '#000' }}
                  >
                    What if I cannot pay my inpatient bill?
                  </button>
                </h2>
                <div id="billsFaq3" className="accordion-collapse collapse" data-bs-parent="#billsFAQAccordion">
                  <div className="accordion-body" style={{ fontSize: '1rem', color: '#333', lineHeight: '1.6' }}>
                    Inpatient patients may be referred to the <strong>Social Services Unit</strong> for assessment and support.
                  </div>
                </div>
              </div>

              <div className="accordion-item" style={{ border: '1px solid #e0e0e0', borderRadius: '8px' }}>
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#billsFaq4"
                    style={{ fontSize: '1.1rem', fontWeight: '600', color: '#000' }}
                  >
                    Are emergency patients required to pay before treatment?
                  </button>
                </h2>
                <div id="billsFaq4" className="accordion-collapse collapse" data-bs-parent="#billsFAQAccordion">
                  <div className="accordion-body" style={{ fontSize: '1rem', color: '#333', lineHeight: '1.6' }}>
                    Emergency care is provided immediately. Billing is addressed after stabilization.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ScrollSection>
      </div>
    </>
  );
}

export default BillsPayments;
